'use client';

import { SessionProvider as NextAuthSessionProvider, useSession } from "next-auth/react";
import { Session } from "next-auth";
import { useEffect } from "react";
import { usePathname } from "next/navigation";

function AutoLogout() {
    const { status } = useSession();
    const pathname = usePathname();

    useEffect(() => {
        // forgot-password/reset-password: quem redefine senha está, por definição, DESLOGADO.
        // Sem estas duas aqui o SSR devolvia 200 e este efeito expulsava o visitante logo após
        // a hidratação — recuperação de senha ficou inutilizável até 2026-08-11.
        // shopify/sso: bridge de auto-login pós-instalação via App Store — o visitante
        // chega SEM sessão de propósito; expulsá-lo aqui mata o signIn antes de disparar.
        // track/relatorio: páginas PÚBLICAS por token opaco (rastreio do cliente final e
        // relatório compartilhado do diagnóstico) — visitante anônimo é o caso NORMAL.
        const isPublicPage = /^\/(login|register|onboarding|privacy|terms|forgot-password|reset-password|shopify\/sso|lp\d+|track|relatorio)/.test(pathname) || pathname === "/";

        if (status === "unauthenticated" && !isPublicPage) {
            console.log("[AUTO-LOGOUT] Session lost, redirecting...");
            window.location.href = "/login?reason=session_expired";
        }
    }, [status, pathname]);

    return null;
}

export default function SessionProvider({ children, session }: { children: React.ReactNode, session?: Session | null }) {
    return (
        <NextAuthSessionProvider
            session={session}
            refetchInterval={30} // Poll every 30 seconds
            refetchOnWindowFocus={true}
        >
            <AutoLogout />
            {children}
        </NextAuthSessionProvider>
    );
}
